import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const sections = [
  {
    title: 'Buyer Obligations',
    icon: 'User',
    color: '#00D4FF',
    items: [
      'Sign RERA-approved Sale and Purchase Agreement (SPA)',
      'Pay DLD transfer fee of 4% of property value',
      'Register property with DLD within 60 days of SPA signing',
      'Ensure all payments go through RERA-approved escrow account',
      'Obtain No Objection Certificate (NOC) from developer before transfer',
      'Pay Dubai Land Department admin fees (AED 4,000 for properties above AED 500K)'
    ]
  },
  {
    title: 'RERA Buyer Protections',
    icon: 'Shield',
    color: '#22c55e',
    items: [
      'Mandatory escrow accounts protect off-plan payments',
      'RERA can cancel project and refund buyers if developer defaults',
      'Developers cannot access escrow funds without construction milestones',
      'Buyers entitled to full refund if project cancelled by RERA',
      'RERA dispute resolution center handles buyer-developer conflicts',
      'Strata law protects owners in jointly owned properties'
    ]
  },
  {
    title: 'Dispute Resolution',
    icon: 'Scale',
    color: '#f59e0b',
    items: [
      'File complaint with RERA Dispute Resolution Center (DRC)',
      'Rental Dispute Settlement Centre for tenancy issues',
      'Dubai Courts for civil property disputes',
      'DIFC Courts for international investors (common law)',
      'Mediation available before formal legal proceedings',
      'RERA arbitration panel for off-plan project disputes'
    ]
  }
];

const LegalRequirements = () => {
  const [open, setOpen] = useState(0);
  const navigate = useNavigate();

  return (
    <div className="rounded-2xl p-6" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,212,255,0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)' }}>
          <Icon name="BookOpen" size={20} color="#00D4FF" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Legal Requirements & Protections</h3>
          <p className="text-xs" style={{ color: '#6B9EC4' }}>UAE property law obligations, RERA protections, and dispute resolution</p>
        </div>
      </div>
      <div className="space-y-3">
        {sections?.map((sec, i) => (
          <div key={i} className="rounded-xl overflow-hidden" style={{ border: '1px solid rgba(0,212,255,0.15)' }}>
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-center justify-between p-4"
              style={{ background: open === i ? 'rgba(0,212,255,0.08)' : 'rgba(0,212,255,0.03)' }}
            >
              <div className="flex items-center gap-3">
                <Icon name={sec?.icon} size={18} color={sec?.color} />
                <span className="font-semibold text-sm" style={{ color: '#E8F4FF' }}>{sec?.title}</span>
              </div>
              <Icon name={open === i ? 'ChevronUp' : 'ChevronDown'} size={16} color="#6B9EC4" />
            </button>
            {open === i && (
              <div className="px-4 pb-4">
                <ul className="space-y-2">
                  {sec?.items?.map((item, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm" style={{ color: '#6B9EC4' }}>
                      <span className="mt-0.5 flex-shrink-0" style={{ color: sec?.color }}>•</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
        <button
          onClick={() => window.open('https://www.rera.gov.ae', '_blank', 'noopener,noreferrer')}
          className="flex items-center justify-center gap-2 py-3 px-4 rounded-xl font-medium text-sm transition-all" style={{ background: '#00D4FF', color: '#0A1628' }}>
          <Icon name="AlertCircle" size={16} color="#0A1628" />
          File RERA Complaint
        </button>
        <button
          onClick={() => navigate('/expat-buyer-guidance')}
          className="flex items-center justify-center gap-2 py-3 px-4 rounded-xl font-medium text-sm transition-all" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', color: '#00D4FF' }}>
          <Icon name="Download" size={16} color="#00D4FF" />
          Download Buyer Guide
        </button>
      </div>
    </div>
  );
};

export default LegalRequirements;
